import { useState } from "react";
import Section from "../UI/Section";
import styled from "styled-components";
import { H700, H800, T300, T400 } from "../Styles";
import Slider from "./Slider";
import I18n from "i18n-js";

const RewardCalculationWrapper = styled.div`
  padding: 120px;
  justify-items: center;

  ${({ theme }) => theme.tablet`
    padding: 64px 24px; 
  `}
`;

const RewardCalculationContent = styled.div`
  display: flex;
  width: 640px;
  padding: 40px;
  flex-direction: column;
  align-items: center;
  background: #FFF;
  border-radius: 24px; 
  gap: 16px;
  box-shadow: 
    0 0.5px 0.25px 0 #0c222d17, 
    0 0 16px 0 #16163708, 
    0 0 1px 0 #0a1b294a inset;
  text-align: center;

  ${({ theme }) => theme.tablet`
    padding: 24px;  
    margin: 64px 0;
    width: 100%;
    gap: 8px;
  `}
`;

const TopWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  ${({ theme }) => theme.tablet`
    gap: 8px;
  `}
`;

const BottomWrapper = styled.div`
  display: flex;
  gap: 16px;

  ${({ theme }) => theme.tablet`
    gap: 8px; 
  `}
`;

const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const HeaderTitle = styled(H700)`
  font-family: Sentient;
`

const BoldMoney = styled.span`
  font-family: Inter, sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 30px;
`;

const CardContainer = styled.div`
  display: flex;
  padding: 32px;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  gap: 8px;
  flex: 1; 
  border-radius: 16px;
  border: 1px solid #E3D0B5;
  background: #F2E9DD;

  ${({ theme }) => theme.tablet`
    padding: 16px; 
    gap: 0px;
  `}
`;

const CashBackAmount = styled(H800)`
  font-family: Sentient;
  color: #785827;
  width: 190px;

  ${({ theme }) => theme.tablet`
    width: unset; 
  `}
`;

const CashBackType = styled(T400)`
  color: #785827;
  line-height: normal;
`;

const CardDivider = styled(T400)`
  align-content: center;
  color: #6F787F;
`;

const RewardCalculation = () => {
  const [spend, setSpend] = useState(500);

  return (
    <Section
      backgroundType="image"
      backgroundData="https://theguestbook.s3.us-east-1.amazonaws.com/public/hotel_landing_trip_adds_up.jpg"
      isHeroImage={true}
      isHotelLanding={true}
    >
      <RewardCalculationWrapper>
        <RewardCalculationContent>
          <TopWrapper>
            <HeaderWrapper>
              <HeaderTitle>
                {I18n.t("views.static_pages.hotel_landing.reward_calculation.title")}
              </HeaderTitle>
              <T300>
                {I18n.t("views.static_pages.hotel_landing.reward_calculation.sub_title")}
              </T300>
            </HeaderWrapper>
            <T400>
              When you spend
              <BoldMoney>&nbsp;${spend}&nbsp;</BoldMoney>
              you earn:
            </T400>
            <Slider
              spend={spend}
              setSpend={setSpend}
              min={100}
              max={5000}
              step={100}
              easeIn={false}
              background={false}
            />
          </TopWrapper>
          <BottomWrapper>
            <CardContainer>
              <CashBackAmount>
                ${spend * .05}
              </CashBackAmount>
              <CashBackType>
                {I18n.t("views.static_pages.hotel_landing.reward_calculation.cash_back")}
              </CashBackType>
            </CardContainer>
            <CardDivider>or</CardDivider>
            <CardContainer>
              <CashBackAmount>
                ${spend * .15}
              </CashBackAmount>
              <CashBackType>
                {I18n.t("views.static_pages.hotel_landing.reward_calculation.cash_forward")}
              </CashBackType>
            </CardContainer>
          </BottomWrapper>
        </RewardCalculationContent>
      </RewardCalculationWrapper>
    </Section>
  )
}

export default RewardCalculation;
